import { mapGetters } from 'vuex'
import expenseAccount from "@/services/expenseAccount";
import moment from 'moment';
import Utils from "@/mixins/Utils";

export default {
  mixins: [Utils],
  computed: {
    ...mapGetters({
      getExpenseSelected: "getExpenseSelected",
      expenseTypes: "expenseTypes"
    }),
    renderType() {
      if (this.expense && Number(this.expense.typeFrais)) {
        return this.expenseTypes.find((item) => item.value === Number(this.expense.typeFrais)).text
      }
      return
    },
    renderTaxe() {
      return (parseFloat(this.getExpenseSelected.amountTVA) * 100 / parseFloat(this.getExpenseSelected.amountHT)).toFixed(2)
    }
  },
  async created() {
    try {
      const { data } = await expenseAccount.getListTypeExpense()
      this.$store.commit('SET_EXPENSE_TYPES', data.map((type) => ({ value: type.Pk, text: type.Name })))
      if (this.getExpenseSelected) {
        this.expense = this.getExpenseSelected
      } else {
        const { data } = await expenseAccount.getListExpense()
        this.expense = data.find((item) => {
          return item.pkNoteDeFrais === Number(this.$route.params.id)
        })
        if (!this.expense) {
          return this.$router.push({ name: '404ErrorPageNotFound' })
        }
        this.$store.commit('EXPENSE_SELECTED', this.expense)
      }
    } catch (error) {
    } finally {
      this.isLoading = false
    }
  },
  data() {
    return {
      expense: {},
      isLoading: true,
      moment,
    }
  },
  methods: {
    async deleteExpense() {
      try {
        const value = await this.$bvModal.msgBoxConfirm('Veuillez confirmer que vous souhaitez le supprimer.', {
          title: 'Veuillez confirmer',
          size: 'md',
          buttonSize: 'sm',
          okTitle: 'OUI',
          okVariant: 'primary',
          cancelTitle: 'NON',
          cancelVariant: 'primary',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        if (value) {
          await expenseAccount.deleteExpense(this.$route.params.id)
          this.callToaster(this.$t('expense-deleted-successful'));
          this.$router.push({ name: 'employee-list' })
          // TO DO 
        }
      } catch (error) {

      }
    }
  }
}